import { api, setConfig, UPDATE_GAME_MESSAGE } from '../..';
import { mapEntityToApi } from './mapper';
import { PropertyType } from '../../../common';

export const assignProviderToPartner = (data: PropertyType): Promise<PropertyType> =>
	api.post('/games/providers/assign-provider-to-partner', mapEntityToApi(data), setConfig(data)).then(() => {
		return { message: UPDATE_GAME_MESSAGE };
	});
